var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeditationSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "meditation_symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-18.8%",
    y: "-18.8%",
    width: "137.5%",
    height: "137.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "path-2",
    points: "0.000790115694 0.126321509 51.0078047 0.126321509 51.0078047 63.8833509 0.000790115694 63.8833509"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apple-TV",
    transform: "translate(-411.000000, -607.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "meditation",
    transform: "translate(420.000000, 616.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#000000",
    points: "61.6325434 4.38366189 63.7578264 4.38366189 63.7578264 2.25837887 61.6325434 2.25837887"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#000000",
    points: "59.5072604 2.2585117 61.6325434 2.2585117 61.6325434 0.133228679 59.5072604 0.133228679"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#000000",
    points: "57.3819774 4.38366189 59.5072604 4.38366189 59.5072604 2.25837887 57.3819774 2.25837887"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#000000",
    points: "59.5072604 6.50894491 61.6325434 6.50894491 61.6325434 4.38366189 59.5072604 4.38366189"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#000000",
    points: "53.1314113 4.38366189 55.2566943 4.38366189 55.2566943 2.25837887 53.1314113 2.25837887"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#000000",
    points: "51.0061283 25.6364921 53.1314113 25.6364921 53.1314113 23.5112091 51.0061283 23.5112091"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#000000",
    points: "55.2566943 25.6364921 57.3819774 25.6364921 57.3819774 23.5112091 55.2566943 23.5112091"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#000000",
    points: "53.1314113 23.5112091 55.2566943 23.5112091 55.2566943 21.385926 53.1314113 21.385926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#000000",
    points: "53.1314113 27.7617751 55.2566943 27.7617751 55.2566943 25.6364921 53.1314113 25.6364921"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#000000",
    points: "11.6897208 22.4485675 13.8150038 22.4485675 13.8150038 20.3232845 11.6897208 20.3232845"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#000000",
    points: "9.56443774 20.3232845 11.6897208 20.3232845 11.6897208 18.1980015 9.56443774 18.1980015"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#000000",
    points: "7.43782642 22.4485675 9.56310943 22.4485675 9.56310943 20.3232845 7.43782642 20.3232845"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#000000",
    points: "9.56443774 24.5738506 11.6897208 24.5738506 11.6897208 22.4485675 9.56443774 22.4485675"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#000000",
    points: "3.18726038 22.4485675 5.3125434 22.4485675 5.3125434 20.3232845 3.18726038 20.3232845"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#000000",
    points: "0 8.63422792 2.12528302 8.63422792 2.12528302 6.50894491 0 6.50894491"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#000000",
    points: "4.24990189 8.63422792 6.37518491 8.63422792 6.37518491 6.50894491 4.24990189 6.50894491"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#000000",
    points: "2.12461887 6.50894491 4.24990189 6.50894491 4.24990189 4.38366189 2.12461887 4.38366189"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#000000",
    points: "2.12461887 10.7595109 4.24990189 10.7595109 4.24990189 8.63422792 2.12461887 8.63422792"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(6.375849, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    fill: "#000000",
    mask: "url(#mask-3)",
    points: "8.50179623 2.2585117 10.6270792 2.2585117 10.6270792 0.133228679 8.50179623 0.133228679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8188679,52.2026626 L41.9158943,52.2026626 L34.0863517,43.5028166 L37.9830581,27.9138657 C38.7894702,28.2370415 39.3180015,29.0184815 39.3177358,29.8871909 L39.3177358,41.5762475 C39.3170717,41.7626083 39.3654219,41.9457811 39.4580045,42.1075683 L43.7085706,49.5460589 C43.8987834,49.8754777 44.2505177,50.0781766 44.6309434,50.0773796 L47.8188679,50.0773796 C48.4057117,50.0773796 48.8815094,50.5531774 48.8815094,51.1400211 C48.8815094,51.7268649 48.4057117,52.2026626 47.8188679,52.2026626 Z M46.0060015,58.96 L34.1107925,60.5826536 L28.55424,57.1099411 L37.8757313,55.8347713 L45.4311125,54.8040091 C46.5778355,54.6431517 47.6376875,55.4423909 47.7985449,56.589114 C47.8122264,56.6866113 47.8188698,56.7850385 47.8188698,56.8835985 C47.8151487,57.9303004 47.0426083,58.8150823 46.0060015,58.96 Z M25.5033962,61.7568725 L5.00079094,58.96 C3.85340377,58.8084408 3.04619472,57.7554958 3.19775396,56.6081087 C3.33589736,55.5623366 4.2297117,54.7823577 5.28451623,54.7869861 C5.37909132,54.7869861 5.47353358,54.7937811 5.56717887,54.807197 L13.1236226,55.8379592 L25.1314717,57.4754898 L30.8197917,61.0310883 L25.5033962,61.7568725 Z M2.12528302,51.1400211 C2.12528302,50.5531774 2.60108075,50.0773796 3.18792453,50.0773796 L6.37584906,50.0773796 C6.75627472,50.0781766 7.10800906,49.8754777 7.29822189,49.5460589 L11.5487879,42.1075683 C11.6413706,41.9457811 11.6897208,41.7626083 11.6890566,41.5762475 L11.6890566,29.8871909 C11.6890566,29.0191457 12.2170566,28.238237 13.0226717,27.9149283 L16.9193781,43.5038792 L9.09089811,52.2026626 L3.18792453,52.2026626 C2.60094792,52.2026626 2.12528302,51.7268649 2.12528302,51.1400211 Z M33.0481509,47.6779351 L33.4732075,45.9893977 L40.1306566,53.3875079 L38.1658325,53.6542309 L33.0481509,47.6779351 Z M12.8452106,53.6542309 L10.884637,53.3875079 L17.542086,45.9893977 L17.9671426,47.6779351 L12.8452106,53.6542309 Z M19.6163623,49.0147381 L31.3904302,49.0147381 L35.6601238,53.9953389 L25.5033962,55.3810234 L15.3466687,53.9995894 L19.6163623,49.0147381 Z M18.0649057,27.7619079 L18.0649057,29.8871909 C18.0653042,30.3443925 18.3579291,30.7500558 18.7917525,30.8945751 L18.7917525,30.8956377 L25.1676015,33.0209208 C25.3858415,33.094243 25.6220136,33.094243 25.8402536,33.0209208 L32.2161026,30.8956377 C32.6497932,30.75072 32.9421525,30.3445253 32.9418868,29.8871909 L32.9418868,27.7619079 L35.8312091,27.7619079 L31.0493223,46.8894551 L19.9574702,46.8894551 L15.1755834,27.7619079 L18.0649057,27.7619079 Z M15.9396226,15.4873358 C17.0382611,17.9472181 18.9017358,19.98656 21.2528302,21.3021102 L21.2528302,25.6366249 L15.9396226,25.6366249 L15.9396226,15.4873358 Z M29.7539623,25.6366249 L29.7539623,21.2957343 C32.1000091,19.9754023 33.9618898,17.9388498 35.0671698,15.4841479 L35.0671698,25.6366249 L29.7539623,25.6366249 Z M17.2062913,12.5863245 C20.3614068,12.0026687 23.3203321,10.639034 25.8136875,8.61948377 C26.7521328,11.7749977 29.6498234,13.9409268 32.9418868,13.9475683 L33.4051985,13.9475683 C32.0768966,17.5127306 28.708323,20.3234174 25.5033962,20.3234174 C21.8128423,20.3234174 18.0850958,16.746566 17.2062913,12.5863245 Z M23.3781132,26.6992664 L23.3781132,22.1543487 C24.0708226,22.3442958 24.7851834,22.4432543 25.5033962,22.4487004 C26.2220075,22.4425902 26.936634,22.3413736 27.6286792,22.1479728 L27.6286792,26.6992664 C27.6286792,27.2861102 28.104477,27.7619079 28.6913208,27.7619079 L30.8166038,27.7619079 L30.8166038,29.1210264 L25.5033962,30.8924498 L20.1901887,29.1210264 L20.1901887,27.7619079 L22.3154717,27.7619079 C22.9023155,27.7619079 23.3781132,27.2861102 23.3781132,26.6992664 Z M25.5033962,2.2585117 C30.5509434,2.02419925 34.8328574,5.92608604 35.0671698,10.973766 C35.08032,11.2564287 35.08032,11.5396226 35.0671698,11.8222853 L32.9418868,11.8222853 C30.0089962,11.8188317 27.6321328,9.4419683 27.6286792,6.50907774 C27.6285464,5.92223396 27.1527487,5.44656906 26.5657721,5.44670189 C26.2840392,5.44670189 26.0139955,5.55867774 25.8147502,5.75779019 C23.1803291,8.40230642 19.7549042,10.114886 16.0586385,10.6353147 C16.6429585,5.86033509 20.6926853,2.26847396 25.5033962,2.2585117 Z M50.8230883,50.066886 C50.3713328,48.7963653 49.1672272,47.9487758 47.8187351,47.9519638 L45.2482053,47.9519638 L41.442886,41.2934521 L41.442886,29.8870581 C41.442886,27.5395502 39.5398279,25.6364921 37.19232,25.6364921 L37.19232,11.8221525 C37.4079034,5.58205585 32.5241358,0.348679245 26.2840392,0.133095849 C26.0238249,0.124063396 25.7634777,0.124063396 25.5032634,0.133095849 C18.1965404,0.133095849 14.0267351,6.13489509 13.8142068,11.7817721 C13.8142068,11.7955864 13.8216453,11.8083381 13.8216453,11.8221525 L13.8142068,11.8221525 L13.8142068,25.6364921 C11.4666989,25.6364921 9.56364075,27.5395502 9.56364075,29.8870581 L9.56364075,41.2934521 L5.75832151,47.9519638 L3.18792453,47.9519638 C1.43137811,47.9483774 0.00451622641,49.3692619 0.000790115693,51.1258083 C-0.00199245283,52.4739019 0.845464151,53.6773434 2.11571925,54.1290989 C0.580866415,55.863994 0.743052075,58.5147532 2.47808,60.049606 C3.10503849,60.6043049 3.88382189,60.9586958 4.71387774,61.0670853 L25.3599396,63.8820226 C25.4555774,63.8945087 25.5522777,63.8945087 25.6479155,63.8820226 L46.2939774,61.0670853 C48.590877,60.7670219 50.2096785,58.6617962 49.9096151,56.3648966 C49.8012257,55.5348408 49.4468347,54.7560574 48.8921358,54.1290989 C50.5470672,53.5406611 51.4116589,51.7219502 50.8230883,50.066886 L50.8230883,50.066886 Z",
    id: "Fill-21",
    fill: "#000000",
    mask: "url(#mask-3)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeditationSymbol);
export default __webpack_public_path__ + "static/media/meditation_symbol.d8021bd449b58eb8a1a2a982c7eb9a58.svg";
export { ForwardRef as ReactComponent };